/* eslint-disable react/jsx-pascal-case */
import React, { Fragment } from 'react';
import cn from 'classnames';
import styles from './Card.module.scss';
// import { Link } from 'react-router-dom';
// import Routes from '../components/Routes';
import Icons from '../components/Icons';
import { ReactComponent as InfoIcon } from '../styles/icon/info.svg';

export default function BaeApiCard(props) {
  const { head, desc, icon, hasAnimation, enteredClassName, status } = props;

  return (
    <Fragment>
      <div
        className={cn(styles.card, enteredClassName, {
          [styles['card--animate']]: hasAnimation,
        })}
      >
        <div className={styles.card__content}>
          <div className={styles.card__top}>
            <div className={styles.card__icon}>
              <img src={icon} alt="ApiCard" />
            </div>
            <div className={styles.card__info}>
              <InfoIcon />
            </div>
          </div>
          <div className={styles.card__center}>
            <strong>{head}</strong>
            <p>{desc}</p>
          </div>
          {/*<Link to={Routes.routes.SYSTEMSTATUS.routes.CURRENTSTATUS.path}>*/}
            <div className={styles.card__bottom}>
              <div className={styles.card__btn}>
                <Icons.system />
                <strong>{status}</strong>
              </div>
            </div>
          {/*</Link>*/}
        </div>
      </div>
    </Fragment>
  );
}
